import { useFragment } from '@apollo/client/react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { AddMetadataFormFragmentDoc } from './AddMetadataForm.gql';
import { convertJsonSchemaToYup } from '../MetadataField/validationSchema';
export function AddMetadataForm(props) {
    const { initialValues, onSubmit, children, from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataFormFragmentDoc,
    });
    if (!complete) {
        return null;
    }
    const { schema } = data;
    const yupSchema = convertJsonSchemaToYup(schema);
    const validationSchema = yup.object().shape({ value: yupSchema });
    return (<Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
      <Form>{children}</Form>
    </Formik>);
}
